import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import {Hr} from "@irati/ui/src/Layout"
import Modal, {ModalInner} from "@irati/ui/src/Modal"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"

export const StyledModal = styled(Modal)`
  ${ModalInner} {
    padding-top: 5px;
  }
`

export const ResponsiveFlex = styled(Flex)`
  flex-direction: column;

  ${minWidthMedia.desktop`
    flex-direction: row;
    align-items: center;
  `}
`
export const ResponsiveButton = styled(Button)`
  margin-top: ${({theme}) => theme.spacing.oneAndHalf};

  ${minWidthMedia.desktop`
    margin: 0;
  `}
`
export const StyledHr = styled(Hr)`
  ${minWidthMedia.desktop`
    margin: 0;
  `}
`
export const StyledImage = styled.img`
  width: 150px;
  height: 150px;
  position: absolute;
  top: -75px;
`
export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${(props) => props.size}px;
`
export const StyledError = styled.div`
  text-align: center;
  margin-top: 10px;
`
